import { gql } from '../../../apollo/__generated__';

export const EVENT = gql(`
  query Event($eventId: ID!) {
    event(eventId: $eventId) {
      id
      name
      type
      description
      lydiaLink
      checkAddress
      maxUsers
      startAt
      endAt
      hasJoined
      waitingListPosition
      numberOfDays
      milestones {
        id
        name
        isVoucherOnly
        prices {
          day
          value
        }
        startAt
        endAt
      }
      place {
        id
      }
      validatedUsersCount
      paidTicketUsersCount
      paidBedroomUsersCount
      usersCount
      isFull
    }
  }
`);
